import {Box, Typography} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import PageHeader from "../../General/PageHeader";
import useErrorStore from "../../../stores/errorStore";

export default function ErrorPage() {
  const error = useErrorStore((state) => state.error)


  if (!error)
    return (
      <Box sx={{height: "100%", mt: 10}}>
        <Grid2 container spacing={2}>
          <Grid2 xs={12}>
            <PageHeader>En feil har oppstått!</PageHeader>
          </Grid2>
        </Grid2>
      </Box>
    )

  return (
    <Box sx={{ height: "100%", mt: 10 }}>
      <Grid2 container spacing={2}>

        {error?.status === 409 ? (
          <>
            <Grid2 xs={12}>
              <PageHeader>
                Beklager, bestilling ikke mulig
              </PageHeader>
            </Grid2>

            {error && (
              <Grid2 xs={12}>
                <Typography>
                  Du har forsøkt å åpne en bestilling som har status kansellert.
                  Dersom du ønsker å bestille Forutsigbar betaling på nytt, ta gjerne kontakt med Steddi kundeservice på telefon <b>55 90 73 50</b>.<br />
                  Kundeservice er åpen alle hverdager fra 9 til 16.
                </Typography>
              </Grid2>
            )}
          </>
        ) : (
          <>
            <Grid2 xs={12}>
              <PageHeader>En feil har oppstått!</PageHeader>
            </Grid2>

            {error && (
              <Grid2 xs={12}>
                <Typography><b>Mottok feilstatus:</b> {error.detail}</Typography>
              </Grid2>
            )}
          </>
        )}

        {error?.status >= 500 && error?.traceId && (
          <Grid2 xs={12}>
            <Typography><b>Sporingsnummer:</b> {error.traceId}</Typography>
          </Grid2>
        )}

      </Grid2>
    </Box>
  )
}